export const actions = {
  DHL_DESCRIPCION_LOAD_REQUESTED: 'DHL_DESCRIPCION_LOAD_REQUESTED',
  DHL_DESCRIPCION_LOAD_SUCCEEDED: 'DHL_DESCRIPCION_LOAD_SUCCEEDED',
  DHL_DESCRIPCION_LOAD_FAILED: 'DHL_DESCRIPCION_LOAD_FAILED',
}

export const getDhlDescripcionAction = dispatch => {
  dispatch({
    type: actions.DHL_DESCRIPCION_LOAD_REQUESTED,
  })
}
